export default "__VITE_ASSET__JQ24fFn0__"